import React, {useEffect} from 'react';
import {scroller} from 'react-scroll';
import {useLocation, useNavigate} from 'react-router-dom';
import ServiceHomePage from "../Services/ServiceHomePage";
import PersonalAnalysis from "./PersonalAnalysis";
import ChildrenAndTeenagers from "./ChildrenAndTeenagers";
import CouplesAndFamilys from "./CouplesAndFamilys";
import TherapeuticSuport from "./TherapeuticSuport";
import Supervision from "./Supervision";
import StudyGroup from "./StudyGroup";
import FinalQuote from "./FinalQuote";
import Contact from "../Contact/Contact";

const Service = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const scrollOffset = -90;

  useEffect(() => {
    // 1. Topo imediato
    
    if (location.state && location.state.scrollTo) {
      window.scrollTo(0, 0);
      const targetId = location.state.scrollTo;
      
      setTimeout(() => {
          scroller.scrollTo(targetId, {
            smooth: true,
            duration: 300,
            offset: scrollOffset
          });
          
          // 2. Limpeza de estado
          navigate(location.pathname, { replace: true, state: {} });
          
      }, 100);
    }
  }, [location, navigate]);

  return (
    <div id="service" className="container-fluid p-0">
      <ServiceHomePage id="initial-service" className="section"/>
      <PersonalAnalysis id="personal-analysis" className="section"/>
      <ChildrenAndTeenagers id="children-and-teenagers" className="section"/>
      <CouplesAndFamilys id="couples-and-familys" className="section"/>
      <TherapeuticSuport id="therapeutic-suport" className="section"/>
      <Supervision id="supervision" className="section"/>
      <StudyGroup id="study-group" className="section"/>
      <FinalQuote id="final-quote" className="section"/>
      <Contact id="contact" className="section"/>
    </div>
  );
}

export default Service;